// Redux
import { AppThunk } from '@redux/configureStore';
// Libraries
import { createSlice } from '@reduxjs/toolkit';
import { AccountInfo } from '@azure/msal-browser';
// Models
import { ISessionState } from './types';
// Utils
import localStorage from '@utils/LocalStorage';
// Constants
import { LoginConstants, SESSION_INACTIVE_STATE } from '@constants/Session';

const initialState: ISessionState = {
    error: '',
    login: false,
    accessToken: '',
    user: null,
    dataCompany: false,
    guideTour: false,
    loginUser: null,
    rol: '',
    activeTour: false,
    inactive: false,
};

const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        setSession: (state, action) => {
            localStorage.set(LoginConstants.USER_TOKEN, action?.payload?.token);
            localStorage.setObject(LoginConstants.USER_DATA, action?.payload?.data);
            localStorage.set(LoginConstants.INACTIVE_SESSION, SESSION_INACTIVE_STATE.SESSION_ACTIVATED);
            localStorage.set(LoginConstants.LOG_OUT, SESSION_INACTIVE_STATE.SESSION_ACTIVATED);
            state.accessToken = action?.payload?.token;
            state.user = action.payload?.data;
        },
        failedSession: (state, action) => {
            state.error = action.payload;
        },
        loginSession: (state, action) => {
            state.login = action.payload;
        },
        setDataCompany: (state, action) => {
            state.dataCompany = action.payload;
        },
        setGuideTour: (state, action) => {
            state.guideTour = action.payload;
        },
        setLoginUser: (state, action) => {
            state.loginUser = action.payload;
        },
        setRol: (state, action) => {
            state.rol = action.payload;
        },
        setActiveTour: (state, action) => {
            state.activeTour = action.payload;
        },
        clearSession: state => {
            localStorage.clearKey(LoginConstants.USER_TOKEN);
            localStorage.clearKey(LoginConstants.USER_DATA);
            localStorage.clearKey(LoginConstants.EMPLOYER_ID);
            localStorage.clearKey(LoginConstants.USER_ID);
            localStorage.clearKey(LoginConstants.INACTIVE_SESSION);
            localStorage.clearKey(LoginConstants.LOG_OUT);
            state.accessToken = '';
            state.user = null;
            state.dataCompany = false;
        },
        setInactive: (state, action) => {
            localStorage.set(LoginConstants.INACTIVE_SESSION, SESSION_INACTIVE_STATE.SESSION_EXPIRED);
            state.inactive = action.payload;
        },
    },
});

/**
 * Action to login user
 * @constructor
 * @param {AccountInfo} activeAccount - data current login user
 */
export const handleLogin = (token: string, activeAccount: AccountInfo): AppThunk => {
    return (dispatch): void => {
        try {
            if (activeAccount) {
                dispatch(setSession({ token: token, data: activeAccount }));
            }
        } catch {
            dispatch(failedSession(LoginConstants.LOGIN_FAILED));
        }
    };
};

export const {
    setSession,
    setDataCompany,
    failedSession,
    clearSession,
    setGuideTour,
    setLoginUser,
    loginSession,
    setRol,
    setActiveTour,
    setInactive,
} = sessionSlice.actions;

export default sessionSlice.reducer;
